/**
 * Validates if an address line contains a PO Box format.
 * Used to prevent shipping to PO Box addresses.
 */
export const isPOBox = (addressLine) => {
    // More comprehensive PO Box regex that handles various formats
    const poBoxRegex = new RegExp([
        // PO Box patterns WITH numbers - includes various separators
        '(?:^|\\s)p[\\.\\s-/\\\\]*o[\\.\\s-/\\\\]*(?:box)?\\s*(?:#|num(?:ber)?)?\\s*\\d+',
        // PO Box patterns WITHOUT numbers but WITH "box"
        '(?:^|\\s)p[\\.\\s-/\\\\]*o[\\.\\s-/\\\\]*box(?:\\s|$)',
        // Just "PO" or "P.O." alone (without "box")
        '(?:^|\\s)p[\\.\\s-/\\\\]*o[\\.\\s-/\\\\]*(?:\\s|$)',
        // Post Office Box patterns with hyphens
        '(?:^|\\s)\\d*[-\\s]*post[-\\s]*office[-\\s]*box(?:\\s*\\d+)?',
        '(?:^|\\s)post\\s*office\\s*box(?:\\s*(?:#|num(?:ber)?)?\\s*\\d+)?(?:\\s|$)',
        // Post Box (without "Office") patterns
        '(?:^|\\s)post\\s*box(?:\\s*(?:#|num(?:ber)?)?\\s*\\d+)?(?:\\s|$)',
        // Simple Box patterns with numbers
        '(?:^|\\s)(?:box|bin)\\s*(?:#|num(?:ber)?)?\\s*\\d+',
        // International variants with or without numbers
        '(?:^|\\s)(?:postboks|boks)(?:\\s*\\d+)?(?:\\s|$)',
        '(?:^|\\s)(?:packstation|paketstation)(?:\\s*\\d+)?(?:\\s|$)',
        // Complex patterns - number at start
        '(?:^|\\s)\\d+\\s*(?:post\\s*office\\s*box|p[\\.\\s-/\\\\]*o[\\.\\s-/\\\\]*b(?:ox)?)',
        // P.O.B. abbreviations with various separators
        '(?:^|\\s)p[\\.\\s-/\\\\]*o[\\.\\s-/\\\\]*b[\\.\\s-/\\\\]*(?:\\d+)?(?:\\s|$)',
        // P-Box and P/Box variations
        '(?:^|\\s)p[-/\\\\](?:box)(?:\\s*\\d+)?(?:\\s|$)',
        // P O B O X pattern (letters separated by spaces) with optional number
        '(?:^|\\s)p\\s+o\\s+b\\s+o\\s+x(?:\\s*\\d+)?(?:\\s|$)',
    ].join('|'), 'i');
    // Check for patterns that are too incomplete to be valid PO Boxes
    const incompletePatterns = [
        /^(?:\s*)box(?:\s*)$/, // Just "Box" alone
        /^(?:\s*)post(?:\s*)$/, // Just "Post" alone
        /^(?:\s*)office(?:\s*)$/, // Just "Office" alone
    ];
    const trimmed = addressLine.trim();
    for (const pattern of incompletePatterns) {
        if (pattern.test(trimmed)) {
            return false;
        }
    }
    return poBoxRegex.test(addressLine);
};
//# sourceMappingURL=poBoxValidation.js.map